import React from 'react';

const DocumentViewer = ({ selectedDocument, documentContent, onDownload, onDownloadPDF, onPrint, onEdit, onReset }) => {
  if (!selectedDocument) {
    return (
      <div className="document-viewer-empty">
        <div className="document-viewer-empty-content">
          <div className="document-viewer-empty-icon">📋</div>
          <h3 className="document-viewer-empty-title">Sélectionnez un document</h3>
          <p className="document-viewer-empty-description">Choisissez un document dans la liste pour le visualiser ou le modifier.</p>
          <div className="document-viewer-empty-features">
            <div className="document-feature-card">
              <div className="document-feature-icon">📋</div>
              <div className="document-feature-title">Documents uniques</div>
              <div className="document-feature-description">Documents génériques valables pour tous les clients</div>
            </div>
            <div className="document-feature-card">
              <div className="document-feature-icon">👁️</div>
              <div className="document-feature-title">Visualisation</div>
              <div className="document-feature-description">Visualisez les documents en temps réel</div>
            </div>
            <div className="document-feature-card">
              <div className="document-feature-icon">🖨️</div>
              <div className="document-feature-title">Impression</div>
              <div className="document-feature-description">Téléchargez et imprimez facilement</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="document-viewer-container">
      <div className="document-viewer-header">
        <div className="document-viewer-title">
          <div className="document-viewer-info">
            <h3>{selectedDocument.documentName}</h3>
            <p className="document-viewer-description">{selectedDocument.description}</p>
          </div>
          <div className="document-viewer-version">
            Version {selectedDocument.version}
          </div>
        </div>
      </div>

      <div className="document-viewer-actions">
        <div className="document-actions-container">
          <button 
            className="document-action-btn html"
            onClick={onDownload}
            title="Télécharger en HTML"
          >
            📄 HTML
          </button>
          <button 
            className="document-action-btn pdf"
            onClick={onDownloadPDF}
            title="Télécharger en PDF"
          >
            📥 PDF
          </button>
          <button 
            className="document-action-btn print"
            onClick={onPrint}
            title="Imprimer le document"
          >
            🖨️ Imprimer
          </button>
          <button 
            className="document-action-btn edit"
            onClick={() => onEdit(selectedDocument)}
          >
            ✏️ Modifier
          </button>
          <button 
            className="document-action-btn reset"
            onClick={() => onReset(selectedDocument)}
          >
            🔄 Réinitialiser
          </button>
        </div>
      </div>

      <div className="document-viewer-content">
        <div className="document-preview-container">
          <iframe
            srcDoc={documentContent}
            title="Document générique"
            className="document-preview-iframe"
            sandbox="allow-same-origin allow-scripts"
          />
        </div>
      </div>
    </div>
  );
};

export default DocumentViewer;
